import type { OrderCellContainerProps } from './OrderCellContainer';

import { Box, Popover, Scrollable } from '@shopify/polaris';
import { OrderCellBase } from './OrderCellBase';
import { useToggle } from '~/hooks/useToggle';
import { LoadingData } from './LoadingData';
import { OrderItem } from './OrderItem';
import { NoData } from './NoData';

interface OrderCellProps extends OrderCellContainerProps {
  isPrevious?: boolean;
}

export const OrderCell: React.FC<OrderCellProps> = ({
  value,
  columnLayout,
  orderCellProps,
  isPrevious,
  isTotalRow,
}) => {
  const { value: itemHovering, setTrue, setFalse } = useToggle(false);
  const { value: active, toggle: toggleActive } = useToggle(false);

  const { orderList, onClickOrderCell, isFetching } = orderCellProps ?? {};

  if (typeof value !== 'string') return null;

  if (isTotalRow || value === '0') {
    return (
      <OrderCellBase
        value={value}
        justifyContent={columnLayout?.align}
        isPrevious={isPrevious}
        isTotalRow={!!isTotalRow}
      />
    );
  }

  const openOrderModal = () => {
    toggleActive();
    onClickOrderCell?.({ isPrevious });
  };

  const getContent = () => {
    if (isFetching) return <LoadingData />;
    if (!orderList || orderList.rows?.length === 0) return <NoData />;

    return (
      <Scrollable horizontal={false} className="max-h-[325px]">
        {orderList?.rows?.map((order) => (
          <OrderItem key={`${order.id}`} order={order} />
        ))}
      </Scrollable>
    );
  };

  return (
    <Popover
      active={active}
      activator={
        <OrderCellBase
          value={value}
          justifyContent={columnLayout?.align}
          interactive={{
            hovering: itemHovering,
            onHoverChange: (v) => (v ? setTrue() : setFalse()),
            onClick: openOrderModal,
          }}
          isPrevious={isPrevious}
        />
      }
      onClose={toggleActive}
    >
      <Box width="291px">{getContent()}</Box>
    </Popover>
  );
};
